import React, { useCallback, useMemo } from "react";

const useListboxInfiniteScroll = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: {
  fetchNextPage: () => void;
  hasNextPage: boolean | undefined;
  isFetchingNextPage: boolean;
}) => {
  const handleScroll = useCallback(
    (event: React.SyntheticEvent) => {
      const listbox = event.currentTarget;
      const isAtBottom =
        listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10;
      if (isAtBottom && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage],
  );

  const listboxProps = useMemo(
    () => ({ onScroll: handleScroll }),
    [handleScroll],
  );

  return { handleScroll, listboxProps };
};

export const noClientFilter = <T>(options: T[]) => options;

export default useListboxInfiniteScroll;
